<template>
  <component
    :is="baseComponent"
    :to="link.path ? link.path : '/'"
    class="nav-item"
    :class="{active : isActive}"
    tag="li"
  >
    <a
      v-if="isMenu"
      class="nav-link sidebar-menu-item"
      :aria-expanded="!collapsed"
      data-toggle="collapse"
      @click="collapseMenu"
    >
      <i :class="link.icon"></i>
      <p>
        {{link.name}}
        <b class="caret"></b>
      </p>
    </a>
    <div v-if="$slots.default || this.isMenu">
      <el-collapse-transition>
        <ul class="nav" v-show="!collapsed">
          <slot></slot>
        </ul>
      </el-collapse-transition>
    </div>

    <slot name="title" v-if="children.length === 0 && !$slots.default && link.path">
      <component
        :to="link.path"
        @click.native="linkClick"
        :is="elementType(link, false)"
        :class="{active: link.active}"
        class="nav-link"
        :target="link.target"
        :href="link.path"
        style="position:relative;"
      >
        <template v-if="addLink">
          <span class="sidebar-mini">{{link.name.substring(0, 1)}}</span>
          <span class="sidebar-normal">{{link.name}}</span>
        </template>
        <template v-else>
          <!-- <template v-if="link.materialIcon === 'diligence'">
            <div class="deligenceIcon">
              <img src="static/img/notes-eye2.svg" />
              <p>{{link.name}}</p>
            </div>
          </template> -->
            <template v-if="link.materialIcon">
            <svg v-if="link.materialIcon==='diligence'" class="absIcon" xmlns="http://www.w3.org/2000/svg" width="30" height="28" viewBox="0 0 15.71 20.519">
              <g id="Group_3301" data-name="Group 3301" transform="translate(-22 -141.497)">
                <g id="test" transform="translate(22 141.497)" opacity="0.85">
                  <g id="Group_3300" data-name="Group 3300">
                    <g id="Group_3299" data-name="Group 3299">
                      <path id="Path_1785" data-name="Path 1785" d="M13.907,2.445H12.063V1.8a.6.6,0,0,0-.6-.6H9.555a1.8,1.8,0,0,0-3.4,0H4.208a.6.6,0,0,0-.6.6v.641H1.8A1.805,1.805,0,0,0,0,4.248V18.716a1.805,1.805,0,0,0,1.8,1.8h12.1a1.805,1.805,0,0,0,1.8-1.8V4.248A1.805,1.805,0,0,0,13.907,2.445Zm-9.1-.04H6.653a.6.6,0,0,0,.6-.6.6.6,0,1,1,1.2,0,.6.6,0,0,0,.6.6h1.8v.641a.6.6,0,0,1-.6.6H5.41a.6.6,0,0,1-.6-.6Zm9.7,16.311a.6.6,0,0,1-.6.6H1.8a.6.6,0,0,1-.6-.6V4.248a.6.6,0,0,1,.6-.6H3.71a1.806,1.806,0,0,0,1.7,1.2H10.26a1.806,1.806,0,0,0,1.7-1.2h1.947a.6.6,0,0,1,.6.6Z"/>
                    </g>
                  </g>
                </g>
                <g id="eye_1_" data-name="eye (1)" transform="translate(24.7 150.584)" opacity="0.85">
                  <path id="Path_1786" data-name="Path 1786" d="M5.225,98.725a6.519,6.519,0,0,0-5.143,2.867.414.414,0,0,0,0,.494,6.516,6.516,0,0,0,5.143,2.869,6.519,6.519,0,0,0,5.143-2.867.414.414,0,0,0,0-.494A6.516,6.516,0,0,0,5.225,98.725Zm.143,5.308a2.2,2.2,0,1,1,2.05-2.05A2.2,2.2,0,0,1,5.368,104.033ZM5.3,103.02a1.184,1.184,0,1,1,1.105-1.105A1.182,1.182,0,0,1,5.3,103.02Z" transform="translate(0 -98.725)" />
                </g>
              </g>
            </svg>
            <i v-if="link.materialIcon==='diligence'"
              :class="link.materialClass?link.materialClass:'material-icons'"
              style="font-size:0px;line-height: 30px;"
            >{{link.materialIcon}}</i>
            <i v-else
              :class="link.materialClass?link.materialClass:'material-icons'"
              style="font-size:25px;line-height: 30px;"
            >{{link.materialIcon}}</i>
          </template>
          <template v-else>
            <i :class="link.icon" style="font-size:25px;line-height: 30px;"></i>
          </template>
          <p>{{link.name}}</p>
        </template>
      </component>
    </slot>
  </component>
</template>
<script>
import CollapseTransition from "element-ui/lib/transitions/collapse-transition";

export default {
  name: "sidebar-item",
  components: {
    [CollapseTransition.name]: CollapseTransition,
  },
  props: {
    menu: {
      type: Boolean,
      default: false,
    },
    link: {
      type: Object,
      default: () => {
        return {
          name: "",
          path: "",
          children: [],
        };
      },
    },
  },
  provide() {
    return {
      addLink: this.addChild,
      removeLink: this.removeChild,
    };
  },
  inject: {
    addLink: { default: null },
    removeLink: { default: null },
    autoClose: {
      default: true,
    },
  },
  data() {
    return {
      children: [],
      collapsed: true,
    };
  },
  computed: {
    baseComponent() {
      return this.isMenu || this.link.isRoute ? "li" : "router-link";
    },
    isMenu() {
      return this.children.length > 0 || this.menu === true;
    },
    isActive() {
      if (this.$route && this.$route.path) {
        let matchingRoute = this.children.find((c) =>
          this.$route.path.startsWith(c.link.path)
        );
        if (matchingRoute !== undefined) {
          return true;
        }
      }
      return false;
    },
  },
  methods: {
    addChild(item) {
      const index = this.$slots.default.indexOf(item.$vnode);
      this.children.splice(index, 0, item);
    },
    removeChild(item) {
      const tabs = this.children;
      const index = tabs.indexOf(item);
      tabs.splice(index, 1);
    },
    elementType(link, isParent = true) {
      if (link.isRoute === false) {
        return isParent ? "li" : "a";
      } else {
        return "router-link";
      }
    },
    linkAbbreviation(name) {
      const matches = name.match(/\b(\w)/g);
      return matches.join("");
    },
    linkClick() {
      if (
        this.autoClose &&
        this.$sidebar &&
        this.$sidebar.showSidebar === true
      ) {
        // this.$sidebar.displaySidebar(false)
      }
    },
    collapseMenu() {
      this.collapsed = !this.collapsed;
    },
    collapseSubMenu(link) {
      link.collapsed = !link.collapsed;
    },
  },
  mounted() {
    if (this.addLink) {
      this.addLink(this);
    }
    if (this.link.collapsed !== undefined) {
      this.collapsed = this.link.collapsed;
    }
    if (this.isActive && this.isMenu) {
      this.collapsed = false;
    }
  },
  destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    if (this.removeLink) {
      this.removeLink(this);
    }
  },
};
</script>
<style>
.sidebar-menu-item {
  cursor: pointer;
}

.active{
  fill: #5445f3;
}

.absIcon{
  position: absolute;
}

</style>
